export const USER_REGISTER_REQUEST = 'USER_REGISTER_REQUEST'
export const USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS'
export const USER_REGISTER_FAIL = 'USER_REGISTER_FAIL'

export const OTP_VERIFICATION_REQUEST = 'OTP_VERIFICATION_REQUEST'
export const OTP_VERIFICATION_SUCCESS = 'OTP_VERIFICATION_SUCCESS'
export const OTP_VERIFICATION_FAIL = 'OTP_VERIFICATION_FAIL'

export const USER_SIGNIN_REQUEST = 'USER_SIGNIN_REQUEST'
export const USER_SIGNIN_SUCCESS = 'USER_SIGNIN_SUCCESS'
export const USER_SIGNIN_FAIL = 'USER_SIGNIN_FAIL'
export const USER_LOGOUT = 'USER_LOGOUT'

export const SET_USER = 'SET_USER'
